import styled from 'styled-components'
import { theme } from '../theme/theme'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { SymptomTrend } from '@estercare/ester-shared'

interface props {
  status: SymptomTrend
  amount?: number
}

export const StatusPill: FC<props> = ({ status, amount }) => {
  const { t } = useTranslation()
  const getColor = () => {
    switch (status) {
      case SymptomTrend.Improving:
        return theme.color.green
      case SymptomTrend.Stable:
        return theme.color.grey3
      case SymptomTrend.NeedsAttention:
        return theme.color.yellow
      default:
        return theme.color.green
    }
  }
  const getStatusText = () => {
    switch (status) {
      case SymptomTrend.Improving:
        return t('employee.yourHealth.improvedInAreas', { count: amount })
      case SymptomTrend.Stable:
        return t('employee.yourHealth.areaStable', { count: amount })
      case SymptomTrend.NeedsAttention:
        return t('employee.yourHealth.needsAttention', { count: amount })
      default:
        return t('employee.yourHealth.improvedInAreas', { count: amount })
    }
  }
  return (
    <Pill>
      <PillDot $color={getColor()} />
      {getStatusText()}
    </Pill>
  )
}
const Pill = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: rgba(255, 255, 255, 0.12);
  color: ${theme.color.white};
  border-radius: 999px;
  padding: ${theme.spacing.xsmall}px ${theme.spacing.medium}px;
  font-size: ${theme.fontSize.small}px;
  font-family: ${theme.font.body};
  white-space: nowrap;
`

const PillDot = styled.span<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`
